import {
  GET_HOSTED_WISHLIST,
  GET_PARTICIPATED_WISHLIST,
  GET_ARCHIVED_HOSTED_WISHLIST,
  GET_ARCHIVED_PARTICIPATED_WISHLIST,
  CREATE_WISHLIST,
  DELETE_WISHLIST,
  ARCHIVE_WISHLIST,
  UNARCHIVE_WISHLIST,
  UPLOAD_WISHLIST_IMAGE,
  JOIN_WISHLIST_BY_UNIQUECODE,
  GET_WISHLIST_DETAIL,
  STORE_SHARE_EVENTID,
  SHARE_WISHLIST,
  CHECK_PARTICIPANT,
  ACCEPT_REJECT_WISHLIST,
  UPDATE_WISHLIST,
  GET_REMAINING_EVENTS_COUNT,
  GET_EVENT_PRICING,
  DELETE_GUEST
} from "./action.type";

import {
  STORE_SHARE_EVENTID_MUTATION,
  SET_JOINED_WISHLIST_ID_MUTATION,
  SET_EVENT_PRICING_MUTATION

} from "./mutation.type";
// import axios from 'axios';
import $axios from "../../helpers/axios-instance";

const baseUrl = process.env.VUE_APP_BASE_API_URL;
const dataPerPage = process.env.VUE_APP_API_PER_PAGE_LIMIT || 10;

export default {
  state: {
    wishlistId: "",
    joinedWishlistId: "",
    eventPricing: {}
  },
  actions: {
    [GET_EVENT_PRICING](context) {
      return new Promise((resolve, reject) => {
        $axios
          .get("/purchase/getEventsPricing")
          .then(response => {
            // console.log(response.data.data)

            resolve(response.data.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [GET_REMAINING_EVENTS_COUNT](context, params) {
      return new Promise((resolve, reject) => {
        $axios
          .get("/purchase/getRemainingEvents")
          .then(response => {
            // console.log(response.data.data)

            resolve(response.data.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [GET_HOSTED_WISHLIST](context, params) {
      return new Promise((resolve, reject) => {
        $axios
          .get("/wishlist/hostedWishlist", {
            params
          })
          .then(response => {
            // console.log(response.data.data)

            resolve(response.data.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [GET_PARTICIPATED_WISHLIST](context, params) {
      return new Promise((resolve, reject) => {
        $axios
          .get("/wishlist/participatedWishlist", {
            params
          })
          .then(response => {
            // console.log(response.data.data)

            resolve(response.data.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    [GET_ARCHIVED_HOSTED_WISHLIST](context, params) {
      return new Promise((resolve, reject) => {
        $axios
          .get("/wishlist/listArchive/hosted", {
            params
          })
          .then(response => {
            // console.log(response.data.data)

            resolve(response.data.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [GET_ARCHIVED_PARTICIPATED_WISHLIST](context, params) {
      return new Promise((resolve, reject) => {
        $axios
          .get("/wishlist/listArchive/participated", {
            params
          })
          .then(response => {
            // console.log(response.data.data)

            resolve(response.data.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [CREATE_WISHLIST](context, body) {
      return new Promise((resolve, reject) => {
        $axios
          .post(
            "/wishlist/create", {
              ...body
            }, {
              timeout: 500000
            }
          )
          .then(response => {
            // console.log(response.data)

            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [CREATE_WISHLIST](context, body) {
      return new Promise((resolve, reject) => {
        $axios
          .post(
            "/wishlist/create", {
              ...body
            }, {
              timeout: 500000
            }
          )
          .then(response => {
            // console.log(response.data)

            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [ACCEPT_REJECT_WISHLIST](context, body) {
      return new Promise((resolve, reject) => {
        $axios
          .post(
            "/wishlistInvitation/acceptReject", {
              ...body
            }, {
              timeout: 500000
            }
          )
          .then(response => {
            // console.log(response.data)

            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [DELETE_WISHLIST](context, id) {
      return new Promise((resolve, reject) => {
        $axios
          .delete("/wishlist/delete/" + id)
          .then(response => {
            // console.log(response.data)

            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [ARCHIVE_WISHLIST](context, id) {
      return new Promise((resolve, reject) => {
        $axios
          .post("/wishlist/archive/" + id)
          .then(response => {
            // console.log(response.data)

            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [UNARCHIVE_WISHLIST](context, id) {
      return new Promise((resolve, reject) => {
        $axios
          .post("/wishlist/unarchive/" + id)
          .then(response => {
            // console.log(response.data)

            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [GET_WISHLIST_DETAIL](context, id) {
      return new Promise((resolve, reject) => {
        $axios
          .get("/wishlist/details/" + id)
          .then(response => {
            // console.log(response.data)

            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [CHECK_PARTICIPANT](context, id) {
      return new Promise((resolve, reject) => {
        $axios
          .get("/wishlist/checkParticipant", {
            params: {
              wishlistId: id
            }
          })
          .then(response => {
            // console.log(response.data)

            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    [UPLOAD_WISHLIST_IMAGE](context, body) {
      return new Promise((resolve, reject) => {
        $axios
          .post(
            "/wishlist/uploadImage", {
              ...body
            }, {
              timeout: 500000
            }
          )
          .then(response => {
            // console.log(response.data)

            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    [ACCEPT_REJECT_WISHLIST](context, body) {
      console.log("Action");
      return new Promise((resolve, reject) => {
        $axios
          .post("/wishlistInvitation/acceptReject/", {
            ...body
          })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [CREATE_WISHLIST](context, body) {
      return new Promise((resolve, reject) => {
        console.log(body);
        $axios
          .post(
            "/wishlist/create", {
              ...body
            }, {
              timeout: 500000
            }
          )
          .then(response => {
            // console.log(response.data)

            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [DELETE_WISHLIST](context, id) {
      return new Promise((resolve, reject) => {
        $axios
          .delete("/wishlist/delete/" + id)
          .then(response => {
            // console.log(response.data)

            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [ARCHIVE_WISHLIST](context, id) {
      return new Promise((resolve, reject) => {
        $axios
          .post("/wishlist/archive/" + id)
          .then(response => {
            // console.log(response.data)

            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    [GET_WISHLIST_DETAIL](context, id) {
      return new Promise((resolve, reject) => {
        $axios
          .get("/wishlist/details/" + id)
          .then(response => {
            // console.log(response.data)

            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    [UPLOAD_WISHLIST_IMAGE](context, body) {
      return new Promise((resolve, reject) => {
        $axios
          .post(
            "/wishlist/uploadImage", {
              ...body
            }, {
              timeout: 500000
            }
          )
          .then(response => {
            // console.log(response.data)

            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    [JOIN_WISHLIST_BY_UNIQUECODE](context, uniqueCode) {
      console.log("Action");
      return new Promise((resolve, reject) => {
        $axios
          .post("/wishlistInvitation/joinByUniqueId/" + uniqueCode)
          .then(response => {
            console.log(response.data.data.wishListId);
            context.commit(
              SET_JOINED_WISHLIST_ID_MUTATION,
              response.data.data.wishListId
            );
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    [STORE_SHARE_EVENTID](context, eventId) {
      context.commit(STORE_SHARE_EVENTID_MUTATION, eventId);
    },

    [SHARE_WISHLIST](context, body) {
      return new Promise((resolve, reject) => {
        $axios
          .post("/wishlist/share/" + body.wishlistId, {
            email: body.email
          })
          .then(response => {
            console.log("From action");
            console.log(response);
            resolve(response);
          })
          .catch(error => {
            console.log("From action");
            console.log(error);
            reject(error);
          });
      });
    },

    [UPDATE_WISHLIST](context, payload) {
      return new Promise((resolve, reject) => {
        $axios
          .patch("/wishlist/update/" + payload.id, {
            ...payload.data
          })
          .then(response => {
            console.log("From action");
            console.log(response);
            resolve(response);
          })
          .catch(error => {
            console.log("From action");
            console.log(error);
            reject(error);
          });
      });
    },

    [DELETE_GUEST](context, body) {
      return new Promise((resolve, reject) => {
        $axios
          .post("/wishlistInvitation/deleteGuest", {
            ...body
          })
          .then(response => {
            console.log('Response', response);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  },
  mutations: {
    // [SET_REPORTED_WISHLIST](state, wishlist) {
    //     state.reportedWishlist = wishlist
    // }

    [STORE_SHARE_EVENTID_MUTATION](state, wishlistId) {
      state.wishlistId = wishlistId;
    },
    [SET_JOINED_WISHLIST_ID_MUTATION](state, wishlistId) {
      state.joinedWishlistId = wishlistId;
    },
    [SET_EVENT_PRICING_MUTATION](state, payload) {
      state.eventPricing = payload;
    }
  },
  getters: {
    getShareWishlistId: state => state.wishlistId,
    getJoinedWishlistId: state => state.joinedWishlistId
  }
};